// import { message } from "antd";
import React, { useEffect, useState } from 'react';
import DataForm from './DataForm';
import RatingForm from './RatingForm';
import { Route, RouteComponentProps } from 'react-router-dom';
import { sbaas } from '@/config';
import Submitted from './Submitted';
import { Button, Form } from 'antd';

const Store2u = ({ history, match }: RouteComponentProps) => {
  console.log(history);

  let data = match.params['data'];

  const [pageType, setPageType] = useState<String>('LOADING');

  const fetchPage = async () => {
    try {
      // var response: any;
      await sbaas
        .script('get_cs_page_info')
        .get({
          query: {
            qr_value: data,
          },
        })
        .then(res => {
          // let r = convertUnixToDate(res);
          // response = addNumberRow(r, query.limit, query.page);
          console.log('res: ', res);
          if (res.data.status) {
            setPageType(res.data.response[0].get_cs_form_info);
            localStorage.setItem('token', res.data.token);
          }
        });
    } catch (error) {}
  };

  useEffect(() => {
    fetchPage();
    // eslint-disable-next-line
  }, []);

  const onClickContactService = () => {
    history.replace('/contact-service');
  };

  return (
    <>
      {pageType === 'SUBMIT_DATA' ? (
        <Route exact strict path="/s2u/:data" component={DataForm} />
      ) : pageType === 'SUBMIT_RATING' ? (
        <Route exact strict path="/s2u/:data" component={RatingForm} />
      ) : pageType === 'SUBMITTED' ? (
        <Submitted />
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <div className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <Form.Item style={{ textAlign: 'center' }}>
            <Button
              onClick={onClickContactService}
              style={{ background: 'none', border: 'none' }}
            >
              <p style={{ color: 'grey', textDecoration: 'underline' }}>
                Contact Service
              </p>
            </Button>
          </Form.Item>
        </div>
      )}
      {/* <p> {localStorage.getItem('token')} </p>
      <button
        onClick={() => {
          setPageType('SUBMIT_DATA');
        }}
      >
        {' '}
        Submit Form{' '}
      </button>
      <button
        onClick={() => {
          setPageType('SUBMIT_RATING');
        }}
      >
        {' '}
        Submit Rating{' '}
      </button>
      <button
        onClick={() => {
          setPageType('SUBMITTED');
        }}
      >
        {' '}
        Submitted{' '}
      </button> */}
    </>
  );
};

export default Store2u;
